/* jshint -W083 */
export default class IBCarouselController {
    /**
     * Creates an instance of IBCarouselController.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} CMSSortableService - Service for CMS sorting operations.
     * @param {Object} $uibModal - Service for opening UI Bootstrap modal dialogs.
     * @param {Object} $interval - AngularJS interval service.
     * @param {Object} $timeout - AngularJS timeout service.
     * @param {Object} $config - Configuration service.
     * @param {Object} TaskInfoService - Service for task information.
     * @param {Object} $q - AngularJS promise service.
     * @param {Object} SheetLoadedService - Service for sheet loading status.
     */
    constructor($scope, TaskDataService, $signals, CMSSortableService, $uibModal, $interval, $timeout, $config, TaskInfoService, $q, SheetLoadedService) {
        this.$scope = $scope;
        this.TaskDataService = TaskDataService;
        this.$signals = $signals;
        this.CMSSortableService = CMSSortableService;
        this.$uibModal = $uibModal;
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.$config = $config;
        this.TaskInfoService = TaskInfoService;
        this.$q = $q;
        this.SheetLoadedService = SheetLoadedService;

        this._taskContext = TaskDataService.fetchContext();
        this.taskInfo = TaskInfoService.getTaskInfo();
        this.$scope.writingDirection = this.taskInfo.getInputLanguage().writingDirection;

        this.$scope.processedCarousels = [];
        this.$scope.isPDFMode = $config.isPDFMode();

        this.initializeCarousels();
        this.setActiveCarousel();
        this.$scope.onAddNewSlide = this.onAddNewSlide.bind(this);
        this.$scope.openCarouselPreferences = this.openCarouselPreferences.bind(this);
        this.$scope.isReady = false;
        this.initializeCarouselHeight();
    }

    /**
     * Initializes the carousels based on the writing direction.
     */
    initializeCarousels() {
        const carousels = this.$scope.writingDirection !== 'rtl' ? this.$scope.contentObj.getCarousels() : this.$scope.contentObj.getCarousels().reverse();
        for (let carouselIdx in carousels) {
            if (carousels.hasOwnProperty(carouselIdx)) {
                const carousel = carousels[carouselIdx];

                if (typeof carousel.content === 'object') {
                    const new_uuid = angular.createUUID();
                    carousel.content.uuid = new_uuid;
                    this._taskContext.write(new_uuid, carousel.content);
                    carousel.content = new_uuid;
                }

                const carouselObj = this._taskContext.read(carousel.content);

                angular.forEach(carouselObj.data.objects, (value, key) => {
                    if (typeof value === 'object') {
                        const new_uuid = angular.createUUID();
                        carouselObj.data.objects.splice(key, 1, new_uuid);
                        value.uuid = new_uuid;
                        carouselObj.data.objects[new_uuid] = value;
                        carouselObj.flagAsDirty();
                        this._taskContext.write(new_uuid, value);
                    }
                });

                const processedCarousel = {
                    objectRefs: carouselObj.getObjects(),
                    preferences: carouselObj.getPreferences(),
                    uuid: carouselObj.getUUID(),
                    id: angular.copy(this.$scope.processedCarousels.length)
                };
                this.$scope.processedCarousels.push(processedCarousel);
            }
        }
    }

    /**
     * Sets the active carousel based on the writing direction and CMS context.
     */
    setActiveCarousel() {
        if (!angular.isDefined(this.$scope.activeCarousel)) {
            this.$scope.activeCarousel = {};
        }
        if (typeof isCMS !== 'undefined' && isCMS) {
            if (this.$scope.writingDirection === 'rtl' && !this.$scope.activeCarousel[this.$scope.contentObj.data.uuid]) {
                this.$scope.activeCarousel[this.$scope.contentObj.data.uuid] = Object.keys(this.$scope.contentObj.getCarousels()).length - 1;
            } else if (!this.$scope.activeCarousel[this.$scope.contentObj.data.uuid]) {
                this.$scope.activeCarousel[this.$scope.contentObj.data.uuid] = 0;
            }
        } else {
            if (this.$scope.writingDirection === 'rtl') {
                this.$scope.activeCarousel[this.$scope.contentObj.data.uuid] = Object.keys(this.$scope.contentObj.getCarousels()).length - 1;
            } else {
                this.$scope.activeCarousel[this.$scope.contentObj.data.uuid] = 0;
            }
        }
    }

    /**
     * Adds a new slide to the carousels.
     * @param {Array} carousels - The array of carousels.
     */
    onAddNewSlide(carousels) {
        this.$scope.contentObj.flagAsDirty();
        const newObj = angular.copy(this.CMSSortableService.getNewElements().carousel.value[0].content.carousels[0]);
        carousels.push(newObj);
        this.$signals.emit("rendering_rows", this.$scope.rows);
    }

    /**
     * Opens the carousel preferences modal.
     * @param {Array} tabs - The array of tabs.
     */
    openCarouselPreferences(tabs) {
        const carouselPreferencesModalInstance = this.$uibModal.open({
            templateUrl: "/views/ib/components/carousel/modal/carouselPreferencesModal.html",
            windowClass: "carousel-preferences",
            keyboard: false,
            backdrop: 'static',
            controller: "CarouselPreferencesModalController",
            resolve: {
                carousels: () => this.$scope.processedCarousels,
                rows: () => this.$scope.rows,
                contentObj: () => this.$scope.contentObj,
                activeCarouselUUID: () => this.$scope.processedCarousels[this.$scope.activeCarousel[this.$scope.contentObj.data.uuid]].uuid
            }
        });

        carouselPreferencesModalInstance.result.then(() => {
        }, () => {
            if (carouselPreferencesModalInstance.activeCarouselIndex) {
                this.$scope.activeCarousel[this.$scope.contentObj.data.uuid] = parseInt(carouselPreferencesModalInstance.activeCarouselIndex, 10);
                this.$signals.emit("rendering_rows", this.$scope.rows);
            }
        });
    }

    /**
     * Initializes the carousel height.
     */
    initializeCarouselHeight() {
        const _d = this.$q.defer();
        this.SheetLoadedService.wait(_d.promise, 'carousel');
        const setCarouselHeight = () => {
            this.$scope.cheight = 100;
            this.$scope.isReady = false;
            let counter = 0;
            let timeout;
            let cheight = 0;
            let oldCheight = 0;
            const interval = this.$interval(() => {
                timeout = this.$timeout(() => {
                    $(".virtual-" + this.$scope.contentObj.data.uuid + " .item").each((index, value) => {
                        if (counter === $(".virtual-" + this.$scope.contentObj.data.uuid + " .item").length) {
                            this.$interval.cancel(interval);
                            this.$timeout.cancel(timeout);
                            this.$scope.isReady = true;
                            _d.resolve('carousel');

                            this.$scope.cheight = cheight + 50;
                        } else if (cheight < $(value).height()) {
                            cheight = $(value).height();
                        }
                        counter++;
                    });
                    if (oldCheight !== cheight) {
                        oldCheight = cheight;
                        counter = 0;
                        cheight = 0;
                    }
                }, 500);
            }, 500);
        };
        if (this.$scope.processedCarousels.length > 0 && !this.$scope.isPDFMode) {
            setCarouselHeight();
        }
    }
}